import { Link } from 'react-router-dom';

export default function Home() {
    // Use build-time environment variable (baked in at Docker build time)
    // VITE_ prefix makes it available to client components
    const instanceName = import.meta.env.VITE_PILLAR_INSTANCE_NAME || 'Anchorbase';

    return (
        <main className="flex min-h-screen flex-col items-center justify-center p-24">
            <div className="z-10 max-w-5xl w-full items-center justify-center text-center">
                <div className="flex justify-center mb-8">
                    <img
                        src="/assets/anchorbase_logo.svg"
                        alt={`${instanceName} logo`}
                        width={360}
                        height={120}
                        className="mx-auto"
                        style={{ maxWidth: 360, height: 'auto' }}
                    />
                </div>
                {/* <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    {instanceName} Portal
                </h1> */}
                {/* <p className="text-xl text-muted-foreground mb-8">
                    User Management Portal for {instanceName} Payments Gateway
                </p> */}
                <div className="flex gap-4 justify-center">
                    <Link
                        to="/login"
                        className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
                    >
                        Login
                    </Link>
                </div>
            </div>
        </main>
    );
}
